export default "__VITE_ASSET__d5b6c16c__"